import { Box } from "@mui-wrapper";
import { runtimeConfig } from "@src/runtime-config";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
/** The maximum rating that can be given */
export const MAX_RATING = 5;

/** Gets a the email message to be sent when we get some feedback. */
export function getFeedbackMessage({
  selectedRating,
  feedbackMessage,
  defaultOpenProjectTarget,
  hasUserAllowedContact = false,
  isInternalUser
}) {
  let message = "";
  if (feedbackMessage) {
    message += `Feedback: ${feedbackMessage}\n`;
  }
  if (selectedRating) {
    message += `Rating: ${selectedRating}/${MAX_RATING}\n`;
  }
  if (defaultOpenProjectTarget) {
    message += `Default project launch target: ${defaultOpenProjectTarget}\n`;
  }
  message += `Internal user: ${isInternalUser ? "Yes" : "No"}\n`;
  message += `The user has allowed contact: ${hasUserAllowedContact ? "Yes" : "No"}\n`;
  message += `App version: ${runtimeConfig.appVersion}\nEnvironment: ${runtimeConfig.appEnv}\n`;
  return message;
}
/**
 * Gets a mail to link with the correct subject and body.
 */
export function getMailHref({
  members,
  additionalEmails,
  subject = "",
  body = ""
}) {
  // If we have no members we just return an empty string.
  let membersMailAddresses = members?.map(member => member.email).join(";") ?? "";

  // Additional properties to append to the mailto link.
  const appendProps = [];
  if (subject) {
    appendProps.push(`subject=${subject}`);
  }
  if (body) {
    appendProps.push(`body=${body}`);
  }
  if (membersMailAddresses.length && additionalEmails?.length) {
    // Add a semicolon to separate the emails.
    membersMailAddresses += ";";
  }
  let url = `mailto:${membersMailAddresses}${additionalEmails?.join(";") ?? ""}`;
  if (appendProps.length) {
    url += `?${appendProps.join("&")}`;
  }
  return url;
}

/**
 * Returns a link element for a shortcut to email someone.
 *
 * @param email The email to be displayed.
 * @param className Optional class name to include in the "a" element.
 * @returns An "a" element with the correct props included.
 */
export function getMailToLink(email, style) {
  return <Box component="a" href={getMailHref({
    members: [{
      email
    }]
  })} sx={{
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    },
    ...style
  }}>
      {email}
    </Box>;
}
/**
 * Function to be called when the user clicks on the contact support link.
 */
export function contactSupport({
  location,
  trackEvent
}) {
  // Track event of click on contact support button
  trackEvent({
    name: WorkspaceEvents.contactSupport,
    props: {
      location
    }
  });
  window.location.href = `mailto:${runtimeConfig.mailSupportAddress}`;
}